import React from 'react';
import ProjectSession from "../../model2/project/project-session";

type Props = {
    className?  : string
    projectId?  : ID
    project?    : ProjectSession
    colorize?   : boolean
    type?       : 'default' | 'list' | 'app-header'
}

export default function ProjectIcon(props:Props) {


    let sessionProject : ProjectSession | undefined | null = props.projectId ? gd.session.projects.get(props.projectId) : props.project;

    // patch to support templates
    // try check in tempaltes
    if (!sessionProject) {
        sessionProject = gd.session.templatesList.get(props.projectId);
    }

    const getColorClass = () => {
        return 'gd-c-font-'+sessionProject?.color;
    };

    // if no project found in session not in templates return false
    if (!sessionProject) {
        console.warn("ProjectIconUI5: no project in session");
        return null;
    }

    const colorClass = (props.colorize)?getColorClass():false;
    let styles = {};

    const type = props.type || 'default';

    return <div className={Classes("gd-ui-project-icon", sessionProject.iconClass, colorClass, type + "-type", props.className)} style={styles}/>;


}
